import { CanvasRectangle } from './cc-rect';

export class CCdrawingAreaRect extends CanvasRectangle {
  constructor(
    id: number,
    x: number,
    y: number,
    width: number,
    height: number,
    public highlightArea?: string,
    oneTime: boolean = false,
    scaleFactor?: number,
  ) {
    super(id, x, y, width, height, oneTime, scaleFactor);
  }
}
